export enum BackgroundType {
  Fixed = 'fixed',
  Scroll = 'scroll',
}
